import React from 'react';
import IFrame from '@/components/iframe';
// import env from '@/env';

function PUSHInnerMessage() {
  return <IFrame src={`https://linkage.jd.com/`} />;
}

export default PUSHInnerMessage;
